import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//utils
import { Translations, convertStringToArray } from '../../../utils';
//rest client
import { eapiClient, aemHostClient } from '../../../restClient';
// children
import Tabs from '../../common/Tabs/Tabs';
import Panel from '../../common/Tabs/Panel';
import UserAdmin from './SubComp/UserAdmin';
import GroupAdmin from './SubComp/GroupAdmin';
import CustomerAdmin from './SubComp/CustomerAdmin';
//action creator
import { setAdminTabIndex, restoreManualCase } from '../actions/actionCreator';
//style
import './AdminPanel.css';

class AdminPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userData: {},
      groupData: {},
      customerData: {},
      glsApprovals: {},
      customerAdminData: [],
      adminData: [],
      unlockSowModalJson: {}
    };
  }

  componentWillMount() {
    this.props.restoreManualCase();
    document.title = `${Translations(this.props.darkTitleBarJson.static_text_darkTitleBar.admin, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
    // User Admin
    aemHostClient("/aemData/formData/json_user")
      .then(({ data }) => {
        this.setState({ pageJson: data.par });
      });

    //unlock modal
    aemHostClient("/aemData/formData/json_unlock-case-screen")
      .then(({ data }) => {
        this.setState({ unlockPageJson: data.par });
      });

    // Group Admin
    aemHostClient("/aemData/formData/json_group-admin")
      .then(({ data }) => {
        this.setState({ groupAdminPageJson: data.par });
      });

    // Customer Admin
    aemHostClient("/aemData/formData/json_customer-admin")
      .then(({ data }) => {
        this.setState({ customerAdminPageJson: data.par });
      });

    /*===================Delete Group popup page json =================*/
    aemHostClient("/aemData/formData/json_delete-group-confirmation")
      .then(({ data }) => {
        this.setState({ deleteGroupJson: data.par });
      });

    // User Data
    eapiClient("/users")
      .then(({ data }) => {
        this.setState({
          userData: data.responseData
        });
      });

    // Group Data
    eapiClient("/usergroup")
      .then(({ data }) => {
        this.setState({
          groupData: data.responseData
        })
      })

    // Customer Data
    // eapiClient("/customers/")
    // .then(({data}) => {
    //   this.setState({
    //     customerAdminData: data.responseData
    //   })
    // })

    aemHostClient("/aemData/formData/json_unlock-sow-screen")
      .then(({ data }) => {
        this.setState({ unlockSowModalJson: data.par });
      });
  }

  rowLinkAllCases = (data) => {
    eapiClient('/users/' + data.id)
      .then(({ data }) => {
        this.props.setUserAdminDetail(data.responseData)
        this.props.history.push("/admin-panel/user-detail/");
      });
  }

  resetAll = () => {
    this.setState({
      customerAdminData: []
    })
  }
  resetApiCall = (queryParam) => {
    console.log("queryParam", queryParam);
    // Customer Data
    let url = "/customers?emailId=" + queryParam
    eapiClient(url)
      .then(({ data: { responseData } }) => {
        if (responseData !== undefined) {
          this.setState({
            customerAdminData: responseData
          })
        }
      })
  }

  rowLinkGls = (data) => {
    eapiClient('/usergroup/' + data.id)
      .then(({ data }) => {
        this.props.setGroupAdminDetail(data.responseData)
        this.props.history.push("/admin-panel/group-detail/");
      });
  }

  rowLinkCustomer = (data) => {
    this.props.setCustomerAdminDetail(data)
    this.props.history.push("/admin-panel/customer-detail/");
  }

  backToCaselist = () => {
    this.props.setAdminTabIndex(0);
    this.props.history.push('/case-list');
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    return (this.state.pageJson && this.state.groupAdminPageJson ? (
      <div id="caseList" className="gdoc-caselist-container">
        <button className="gdocs-exit-admin-btn" onClick={this.backToCaselist}>
          <div className='gdocs-btn-with-icon_flex'>
            <i className="icon icon-delete" aria-hidden='true'></i>
            {this.translations(this.props.darkTitleBarJson.static_text_darkTitleBar.exitAdmin)}
          </div>
        </button>
        <Tabs selected={this.props.activeTabIndex}>
          <Panel label={this.translateWord(this.state.pageJson.tab_pageTab.text)[0]}>
            {
              typeof this.state.userData.data !== 'undefined' && this.state.userData.data.length > 0
                ? <UserAdmin
                  pageJson={this.state.pageJson}
                  unlockPageJson={this.state.unlockPageJson}
                  GridData={this.state.userData}
                  rowLinkAllCases={(data) => this.rowLinkAllCases(data)}
                  lang={this.props.lang}
                  history={this.props.history}
                  unlockSowModalJson={this.state.unlockSowModalJson}
                />
                : <div>{this.translations(this.state.pageJson.table_adminList.noRecordFound)}</div>
            }
          </Panel>
          <Panel label={this.translateWord(this.state.pageJson.tab_pageTab.text)[1]}>
            {
              typeof this.state.groupData !== 'undefined' && this.state.groupData.length > 0
                ? <GroupAdmin
                  history={this.props.history}
                  pageJson={this.state.groupAdminPageJson}
                  GridData={this.state.groupData}
                  rowLinkGls={(data) => this.rowLinkGls(data)}
                  deleteGroupJson={this.state.deleteGroupJson}
                  lang={this.props.lang}
                />
                : <div>{this.translations(this.state.pageJson.table_adminList.noRecordFound)}</div>
            }
          </Panel>
          <Panel label={this.translateWord(this.state.pageJson.tab_pageTab.text)[2]}>
            <CustomerAdmin
              history={this.props.history}
              pageJson={this.state.customerAdminPageJson}
              GridData={this.state.customerAdminData}
              resetApiCall={(str) => this.resetApiCall(str)}
              resetAll={() => this.resetAll()}
              rowLinkCustomer={(data) => this.rowLinkCustomer(data)}
              lang={this.props.lang}
            />
          </Panel>
        </Tabs>
      </div>
    ) : '');
  }
}

AdminPanel.propTypes = {
  userData: PropTypes.array,
  glsApprovals: PropTypes.array,
};

const mapStateToProps = state => ({
  lang: state.lang
})

const mapDispatchToProps = dispatch => {
  return {
    setAdminTabIndex: index => {
      dispatch(setAdminTabIndex(index))
    },
    restoreManualCase: newCase => {
      dispatch(restoreManualCase(newCase))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminPanel);


// WEBPACK FOOTER //
// ./src/components/Admin/AdminPanel/AdminPanel.js